import React, {useEffect} from 'react'
import {Button} from "semantic-ui-react";
import useSound from 'use-sound'
import '../../style.css'

function PronunciationCard(props) {

    return (
        <div style={props.style}>
            <button className={props.pronunciationButtonStyle} onClick={() => props.file.play()} >
                {props.name}
            </button>
        </div>
    )
}

PronunciationCard.defaultProps = {
    name: '',
    file: 'sa1.mp3',
    pronunciationButtonStyle: 'pronunciationButtonStyle'

}

export default PronunciationCard
